// extracted by mini-css-extract-plugin
export default {"HeroCardImage":"JVL7arPcH_","DisclaimerOnImage":"kUM9xWTFZ3"};